import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Report = () => {
    const [stats, setStats] = useState(null);
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        api.get("/dashboard/stats").then(({ data }) => setStats(data));
        api.get("/activity-logs?limit=50").then(({ data }) => setLogs(data)).catch(() => {});
    }, []);

    if (!stats) return <div className="text-elegant">Caricamento...</div>;

    return (
        <div className="space-y-6" data-testid="report-page">
            <div>
                <div className="text-xs uppercase tracking-[0.3em] text-brand mb-2">Analisi</div>
                <h1 className="font-display text-4xl font-bold">Report</h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-surface border border-[#1f2c44] rounded-lg p-5">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-elegant">Incasso oggi</div>
                    <div className="font-display text-3xl font-bold text-brand">€ {stats.revenue_today.toFixed(2)}</div>
                </div>
                <div className="bg-surface border border-[#1f2c44] rounded-lg p-5">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-elegant">Documenti emessi</div>
                    <div className="font-display text-3xl font-bold">{stats.documents_today}</div>
                </div>
                <div className="bg-surface border border-[#1f2c44] rounded-lg p-5">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-elegant">Camerieri attivi</div>
                    <div className="font-display text-3xl font-bold">{stats.active_waiters}</div>
                </div>
            </div>

            <div className="bg-surface border border-[#1f2c44] rounded-lg p-6">
                <div className="font-display text-xl font-bold mb-4">Activity Log</div>
                <div className="space-y-2 max-h-[500px] overflow-y-auto">
                    {logs.map((l, i) => (
                        <div key={i} className="flex justify-between items-start border-b border-[#1f2c44] pb-2 text-sm">
                            <div>
                                <div className="text-warm font-medium">{l.action}</div>
                                <div className="text-[10px] text-elegant uppercase tracking-wider">
                                    {Object.entries(l.details || {}).slice(0, 3).map(([k, v]) => `${k}: ${v}`).join(" · ")}
                                </div>
                            </div>
                            <div className="text-xs text-elegant whitespace-nowrap">{new Date(l.timestamp).toLocaleString("it-IT")}</div>
                        </div>
                    ))}
                    {logs.length === 0 && <div className="text-elegant text-sm">Nessun log.</div>}
                </div>
            </div>
        </div>
    );
};

export default Report;
